import React, { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

import _ from "lodash";

import {
  globalVariable,
  setGlobalVariable,
} from "../../store/reducers/globals";

import PerfectScrollbar from "react-perfect-scrollbar";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";

import {
  ActualSizeViewIcon,
  AngleIcon,
  AppIcon,
  AreaIcon,
  ArrowIcon,
  BIcon,
  BrightnessIcon,
  ContrastIcon,
  DrawingMenuIcon,
  EllipseIcon,
  EnhanceMenuIcon,
  EyonixGridA,
  EyonixGridB,
  EyonixGridC,
  FirstFrameIcon,
  FitToScreeIcon,
  FlyingZoomIcon,
  FreehandIcon,
  FullHeightIcon,
  Fullscreen2Icon,
  FullWidthIcon,
  GammaIcon,
  GIcon,
  HistoryIcon,
  InfoMenuIcon,
  LastFrameIcon,
  LineIcon,
  MeasureIcon,
  MeasureMultiPointIcon,
  NegativeIcon,
  NextFrameIcon,
  PanIcon,
  PointerIcon,
  PreviousFrameIcon,
  RectangleIcon,
  RelatedEyonixIcon,
  RIcon,
  SaveIcon,
  SharpenIcon,
  SmartViewIcon,
  SmoothIcon,
  SplitMenuIcon,
  SplitODOSIcon,
  StudyListMenuIcon,
  SwitchEyonixIcon,
  SwitchIcon,
  TextIcon,
  TrashIcon,
  View11Icon,
  View21Icon,
  View2x2Icon,
  View31Icon,
  ViewMenuIcon,
  XupGridIcon,
  ZoomIcon,
} from "../../components/icons/icons";
import DvrIcon from "@mui/icons-material/Dvr";
import AppsIcon from "@mui/icons-material/Apps";
import {
  ToolbarButton,
  ToolbarButtonGroup,
  ToolbarButtonGroupMain,
  ToolbarMainColorToggleButton,
  ToolbarMainTBG,
  ToolbarMainToggleButton,
  ToolbarSubTBG,
  ToolbarSubToggleButton,
  ToolbarWindow,
} from "./toolbarCustom";
import clsx from "clsx";

import Tooltip from "@mui/material/Tooltip";
import Slider from "@mui/material/Slider";

import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import Formatter from "../../util/formatter";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { documents, getGroupId, studies } from "../../store/reducers/documents";
import axios from "axios";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { patient as patientPreferences } from "../../store/reducers/preferences";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import CloseIcon from "@mui/icons-material/Close";
import cornerstoneTools from "cornerstone-tools";
import config from "../../app/config";
import { useParams } from "react-router-dom";
import { hasPermission, Permissions } from "../../store/reducers/user";
import MedicationIcon from "@mui/icons-material/Medication";
import MessageBox from "../../util/messageBox";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import RotateRightIcon from '@mui/icons-material/RotateRight';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
const appAxios = axios.create({
  baseURL: config.externalAppsUrl,
});

const useStyles = makeStyles((theme) => ({
  toolbarElement: {
    backgroundColor: theme.palette.tb.background.window,
  },
  toolbarElementSpacing: {
    marginTop: 1,
  },
  toolbarCheck: {
    marginLeft: 5,
  },
  toolbarElementSpacingText: {
    marginTop: 3,
    fontSize: "90%",
    padding: "4px 8px",
  },
  toolbarCenter: {
    position: "absolute",
    width: "100vw",
    textAlign: "center",
    lineHeight: "46px",
  },
  toolbarDisabledCenter: {
    opacity: 0.5
  },
  toolbarRight: {
    position: "absolute",
    right: 0,
  },
  toolbarNumber: {
    backgroundColor: "#434343",
    display: "inline",
    padding: "4px 16px",
    fontWeight: "bold",
    borderRadius: "10px",
  },
  sliderElement: {
    padding: "0 5px",
    lineHeight: 0,
    height: 42,
  },
  sliderLabel1: {
    float: "left",
  },
  sliderLabel2: {
    float: "right",
  },
  studiesList: {
    padding: "2px 0",
    maxHeight: 190,
  },
  studiesListTable: {
    borderCollapse: "collapse",
    borderSpacing: 0,
    "& td": {
      cursor: "pointer",
      padding: "7px 5px",
      borderBottom: "1px solid #000",
      userSelect: "none",

      // #2280f7 !important
      "&.active": {
        cursor: "inherit",
        backgroundColor: "#2280f7 !important",
      },
    },
    "& td:first-child": {
      paddingLeft: 7,
    },
    "& td:last-child": {
      paddingRight: 40,
    },
  },
  studiesListColorDot: {
    width: 16,
    height: 16,
    borderRadius: "50%",
    verticalAlign: "middle",
  },
  studiesListColorInfo: {
    marginLeft: 4,
    fontSize: "12px",
    verticalAlign: "middle",
  },

  selectorItem: {
    padding: "4px 8px",
    "& label": {
      transform: "translate(0, -2px) scale(0.75)",
      marginRight: 0,
    },
  },
  selectorItemFormControl: {
    width: "100%",
  },
  selectorItemSelect: {
    width: "100%",
    fontSize: "80%",
    marginTop: "9px !important",
  },
  selectorItemLabel: {
    fontSize: "80%",
  },
}));

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 300,
    },
  },
};

function ToolbarDICOM(props) {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  let { patientId } = useParams();
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const isHoldingPen = patientId === config.modules.holdingPen.name;
  // console.log(props.viewerId);
  const variableName = "toolbarViewer" + props.viewerId;
  const toolbarViewer = useSelector(globalVariable(variableName));
  // console.log("toolbarViewer", toolbarViewer);
  const savingDor = useSelector(globalVariable("savingDor"));
  // const [valueZoom, setValueZoom] = React.useState(100);
  const [sliderValue, setSliderValue] = React.useState({ blur: 0, sharpen: 0 });
  //
  // const handleValueChange = (mtd, propertyName) => (event, newValue) => {
  //     mtd(newValue);
  // };
  //
  // const handlePropertyChange = (value, propertyName) => {
  //     const newToolBarDef = _.cloneDeep(toolbarViewer);
  //     newToolBarDef.enhanceModeParameters[propertyName] = value;
  //     updateToolbar(newToolBarDef);
  // };

  const handleSliderValueChange = (propertyName) => (event, newValue) => {
    let sliderTmp = _.cloneDeep(sliderValue);
    sliderTmp[propertyName] = newValue;
    setSliderValue(sliderTmp);
  };

  const handlePropertyValueChange = (propertyName) => (event, newValue) => {
    const newToolBarDef = _.cloneDeep(toolbarViewer);
    newToolBarDef.enhanceModeParameters[propertyName] = newValue;
    let sliderTmp = _.cloneDeep(sliderValue);
    sliderTmp[propertyName] = newValue;
    setSliderValue(sliderTmp);
    updateToolbar(newToolBarDef);
  };

  const handleToolPropertyValueChange = (propertyName) => (event) => {
    const newToolBarDef = _.cloneDeep(toolbarViewer);
    newToolBarDef.toolsProperties[propertyName] = event.target.value;
    updateToolbar(newToolBarDef);
  };

  const [studyDocuments, setStudyDocuments] = useState([]);
  const [studyDocumentsCurrentIndex, setStudyDocumentsCurrentIndex] =
    useState(0);
  const documentsObject = useSelector(documents);

  const canModifyDocument = dispatch(
    hasPermission(Permissions.CAN_MODIFY_PATIENT_RECORD),
  );

  const [studiesAvailable, setStudiesAvailable] = useState([]);
  const [studiesByProcedureNameAvailable, setStudiesByProcedureNameAvailable] =
    useState(false);

  const studiesObject = useSelector(studies);
  useEffect(() => {
    if (studiesObject) {
      // build simple list date ordered
      const getStudies = (studies, returnArray) => {
        _.forEach(studies, (study) => {
          if (study.__isGroup) {
            getStudies(study.data, returnArray);
          } else if (study.__isStudy) {
            returnArray.push(study);
          }
        });
      };

      let studiesAvailableLocal = [];
      getStudies(studiesObject, studiesAvailableLocal);
      studiesAvailableLocal = _.cloneDeep(studiesAvailableLocal);

      if (props.activeDocument) {
        _.forEach(studiesAvailableLocal, (study) => {
          if (study.groupId === getGroupId(props.activeDocument)) {
            study.__isActive = true;
          }
        });
      }

      if (studiesByProcedureNameAvailable)
        studiesAvailableLocal = studiesAvailableLocal.filter((study) => {
          return study.__typeString.includes(
            props.activeDocument?.metadata?.procedureName,
          );
        });

      setStudiesAvailable(studiesAvailableLocal);
    }
  }, [studiesObject, props.activeDocument, studiesByProcedureNameAvailable]);

  // useEffect(()=>{
  //     setStudiesByProcedureNameAvailable(false)
  // },[props.activeDocument]);

  const openStudyInActiveView = (study) => () => {
    props.onOpenDocumentInActiveView(study.documents[0]);
  };

  const handleKeyDown = (event) => {
    if (event.keyCode == 18 && toolbarViewer) {
      let newMethod;
      switch (toolbarViewer.activeMethod) {
        case "pan":
          newMethod = "zoom";
          break;
        case "zoom":
          newMethod = "pan";
          break;
      }
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.activeMethod = newMethod;
      updateToolbar(newToolBarDef);
    }
  };

  const handleKeyUp = (event) => {
    if (event.keyCode == 18 && toolbarViewer) {
      let newMethod;
      switch (toolbarViewer.activeMethod) {
        case "pan":
          newMethod = "zoom";
          break;
        case "zoom":
          newMethod = "pan";
          break;
      }
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.activeMethod = newMethod;
      updateToolbar(newToolBarDef);
    }
  };

  const handleMouseDown = (event) => {
    if (toolbarViewer && event.button === 2) {
      event.stopPropagation();
      event.preventDefault();

      let newMethod = "zoom";
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.activeMethod = newMethod;
      newToolBarDef.mouseButton = 2;

      updateToolbar(newToolBarDef);
    }
  };

  const handleMouseUp = (event) => {
    if (toolbarViewer && event.button === 2) {
      event.stopPropagation();
      event.preventDefault();

      let newMethod = "pan";
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.activeMethod = newMethod;
      newToolBarDef.mouseButton = 1;

      updateToolbar(newToolBarDef);
    }
  };

  const preventDefaultEvent = (e) => {
    e.preventDefault();
  };

  const [withText, setWithText] = useState(false);

  useEffect(() => {
    setWithText(toolbarViewer?.toolsProperties?.annotationText || false);

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    window.addEventListener("mousedown", handleMouseDown);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("contextmenu", preventDefaultEvent);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      window.removeEventListener("mousedown", handleMouseDown);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("contextmenu", preventDefaultEvent);
    };
  }, [toolbarViewer]);

  useEffect(() => {
    let sliderTmp = _.cloneDeep(sliderValue);
    let needChange = false;
    if (toolbarViewer?.enhanceMode?.blur) {
      sliderTmp["blur"] = toolbarViewer.enhanceModeParameters["blur"];
      needChange = true;
    }
    if (toolbarViewer?.enhanceMode?.sharpen) {
      sliderTmp["sharpen"] = toolbarViewer.enhanceModeParameters["sharpen"];
      needChange = true;
    }
    if (needChange) {
      setSliderValue(sliderTmp);
    }
  }, [toolbarViewer?.enhanceMode?.blur, toolbarViewer?.enhanceMode?.sharpen]);

  useEffect(() => {
    if (!appList) getExternalApp();
    return () => {};
  }, []);

  // const [windows, setWindows] = useState(["view", "drawing", "info"]);
  // const [windows, setWindows] = useState(["view", "info"]);
  // const [windows, setWindows] = useState(["view"]);
  let openedWindows = [];
  if (props.splitStatus) {
    openedWindows.push("open-od-os");
  }
  if (props.historyMode) {
    openedWindows.push("open-history");
  }
  const [windows, setWindows] = useState(openedWindows);

  useEffect(
    () => {
      setWindows((windows) => {
        const windowsClone = _.cloneDeep(windows);
        _.remove(windowsClone, (w) => w === "open-od-os");
        if (props.splitStatus) {
          windowsClone.push("open-od-os");
        }
        return windowsClone;
      });

    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.splitStatus],
  );

  useEffect(
    () => {

      setWindows((windows) => {
        const windowsClone = _.cloneDeep(windows);
        _.remove(windowsClone, (w) => w === "open-history");
        if (props.historyMode) {
          windowsClone.push("open-history");
        }
        return windowsClone
      });

    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.historyMode],
  );

  useEffect(
    () => {

      setWindows((windows) => {
        const windowsClone = _.cloneDeep(windows);
        if (!props.smartViewMode) {
          _.remove(windowsClone, (w) => w === "open-od-os");
          _.remove(windowsClone, (w) => w === "open-history");
          _.remove(windowsClone, (w) => w === "smart-view-open");
        } else {
          windowsClone.push("smart-view-open");
        }
        return windowsClone;
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.smartViewMode],
  );

  const handleMainToolbar = (event, value) => {
    const openODOS = _.indexOf(value, "open-od-os") >= 0;
    const historyOpened = _.indexOf(value, "open-history") >= 0;
    const historyDSUOpened = _.indexOf(value, "open-history-od-os") >= 0;

    const smartViewIsOpened = _.indexOf(windows, "smart-view-open") >= 0;
    const smartViewToClose = _.indexOf(value, "smart-view-close") >= 0;

    if (props.historyMode !== historyOpened) {
      props.historySwitch(historyOpened);
      if (openODOS) value.splice(_.indexOf(value, "open-od-os"), 1);
    }

    if (props.splitStatus !== openODOS) {
      props.updateOdOsMode(openODOS);
    }

    if (props.historyOdOsMode !== historyDSUOpened) {
      props.historyOdOsSwitch(historyDSUOpened);
    }

    if (smartViewToClose && smartViewIsOpened) { //props.smartViewMode &&
      value.splice(_.indexOf(value, "smart-view-close"), 1);
      props.closeSmartView(smartViewIsOpened);
    }

    if (toolbarViewer) {
      const openRelatedIdx = _.indexOf(value, "open-related");
      if (openRelatedIdx >= 0) {
        value.splice(openRelatedIdx, 1);
        props.onSplit();
      }
      const switchRelatedIdx = _.indexOf(value, "switch-related");
      if (switchRelatedIdx >= 0) {
        value.splice(switchRelatedIdx, 1);
        props.onRelatedSwitch();
      }
    }

    setWindows(value);
  };

  // const [viewMode, setViewMode] = useState("v1x1");
  const [viewMode, setViewMode] = useState(null);
  const handleViewMode = (event, value) => {
    if (value) {
      // setViewMode(value);
      if (props.onViewModeChange) {
        props.onViewModeChange(value);
      }
    }
  };

  const updateToolbar = (newToolBarDef) => {
    //console.log("updateToolbar on slider", newToolBarDef);
    dispatch(
      setGlobalVariable({
        name: variableName,
        value: newToolBarDef,
      }),
    );
  };

  const sendOpenToParent = (position) => () => {
    if (props.onOpen) {
      props.onOpen(position);
    }
  };

  const sendQuickAction = (action, parameter) => () => {
    dispatch(
      setGlobalVariable({
        name: "toolbarViewerQuickAction",
        value: action + ":" + parameter,
      }),
    );
  };

  const [appList, setAppList] = useState(null);

  const openApp = (value, event) => {
    const options = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    appAxios
      .post(
        "/" + value,
        {
          patientId: patientId,
        },
        options,
      )
      .then((response) => {
        console.log(response.data);
      });
  };

  const handleInfo = (event, value) => {
    if (toolbarViewer) {
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.imageInformation = value;
      updateToolbar(newToolBarDef);
    }
  };
  const handleRelatedVisible = (event, value) => {
    if (toolbarViewer) {
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.relatedVisible = value;
      updateToolbar(newToolBarDef);

      props.updateRelatedVisibility(
        props.viewerId - 1,
        !(value && value.length > 1),
      );
    }
  };

  const handleRelatedFramesVisible = (event, value) => {
    if (toolbarViewer) {
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.relatedFramesVisible = value;
      newToolBarDef.relatedVisible = null;
      updateToolbar(newToolBarDef);

      props.updateRelatedFramesVisibility(!!value);
    }
  };

  const getExternalApp = () => {
    appAxios
      .get("")
      .then((response) => {
        setAppList({ data: response.data, keys: Object.keys(response.data) });
      })
      .catch((error) => {
        console.log(error);
        setAppList({ data: {}, keys: [] });
      });
  };

  const handleChannelsMode = (event, value) => {
    if (toolbarViewer) {
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.channelsMode = value;
      updateToolbar(newToolBarDef);

      // TODO: do the job!
    }
  };

  const handleEnhanceMode = (event, value) => {
    if (toolbarViewer) {
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.enhanceMode = value;
      updateToolbar(newToolBarDef);

      // TODO: do the job!
    }
  };

  const handleGridMode = (event, value) => {
    if (toolbarViewer) {
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.grid = value;
      updateToolbar(newToolBarDef);

      // TODO: do the job!
    }
  };

  const handleActiveMethod = (event, value) => {
    if (value && toolbarViewer) {
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.activeMethod = value;
      updateToolbar(newToolBarDef);

      // TODO: select tool from cornerstone here !
    }
  };

  const handleActiveGrid = (event, value) => {
    if (value && toolbarViewer) {
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.activeXUP = value === "grid-clear" ? null : value;
      updateToolbar(newToolBarDef);
    }
  };

  // FIXME: poor function......
  const positionToolbarWindow = (name) => {
    let left = 0;

    const boxWidth = 145;
    const buttonWidth = 46;

    let vOpen, eOpen, dOpen, sOpen;
    vOpen = _.indexOf(windows, "view") > -1;
    eOpen = _.indexOf(windows, "enhance") > -1;
    dOpen = _.indexOf(windows, "drawing") > -1;
    sOpen = _.indexOf(windows, "study") > -1;

    switch (name) {
      case "enhance":
        left = vOpen ? boxWidth + 45 : buttonWidth;
        break;
      case "drawing":
        left = vOpen
          ? eOpen
            ? boxWidth * 2 + 45
            : boxWidth + 45
          : eOpen
            ? boxWidth + buttonWidth
            : buttonWidth * 2;
        break;
      case "study":
        left = vOpen
          ? eOpen
            ? dOpen
              ? boxWidth * 3 + 2 * (buttonWidth + 1)
              : boxWidth * 2 + 45
            : dOpen
              ? boxWidth * 2 + 2 * buttonWidth
              : boxWidth + 45
          : eOpen
            ? dOpen
              ? boxWidth * 2 + 2 * (buttonWidth + 1)
              : boxWidth + buttonWidth
            : dOpen
              ? boxWidth + buttonWidth * 3
              : buttonWidth * 4;
        break;
      case "change-grid":
        // it may not be best idea ...
        left = vOpen
          ? eOpen
            ? dOpen
              ? sOpen
                ? boxWidth * 5 + 3 * (buttonWidth + 1) // v + e + d + s
                : boxWidth * 3 + 2 * (buttonWidth + 1) // v + e + d
              : sOpen
                ? boxWidth * 4 + 2 * buttonWidth // v + e + s
                : boxWidth * 2 + 45 // v + e
            : dOpen
              ? sOpen
                ? boxWidth * 5 - 5 // v + d + s
                : boxWidth * 2 + 2 * buttonWidth // v + d
              : sOpen
                ? boxWidth * 3 + 2 * buttonWidth // v + s
                : boxWidth + 45 // v
          : eOpen
            ? dOpen
              ? sOpen
                ? boxWidth * 5 - 5 // e + d + s
                : boxWidth * 2 + 2 * buttonWidth // e + d
              : sOpen
                ? boxWidth * 3 + 2 * buttonWidth // e + s
                : boxWidth + buttonWidth // e
            : dOpen
              ? sOpen
                ? boxWidth * 4 + buttonWidth - 8 // d + s
                : boxWidth * 2 - 5 // d
              : sOpen
                ? boxWidth * 3 + 2 * buttonWidth - 7 // s
                : buttonWidth * 4; // nothing else
        break;
      case "app":
        left = buttonWidth * 4;
        break;
      case "smart-view":
        left = buttonWidth * 5;
        break;
      default:
        left = 0;
        break;
    }

    return left;
  };

  const disabledTools = () => {
    return (
      props.activeDocument &&
      props.activeDocument.metadata?.isOldCopy &&
      !props.activeDocument.metadata.finalPages
    );
  };

  const patientPreferencesObject = useSelector(patientPreferences);

  const setSmartView = (view) => {
    const windowsClone = _.cloneDeep(windows);
    _.remove(windowsClone, (w) => w === "smart-view");
    if (props.openSmartView) props.openSmartView(view);
    setWindows(windowsClone);
  };

  const handleAnnotationText = (ev) => {
    if (toolbarViewer) {
      const newToolBarDef = _.cloneDeep(toolbarViewer);
      newToolBarDef.toolsProperties.annotationText = ev.target.checked;
      updateToolbar(newToolBarDef);

      // TODO: select tool from cornerstone here !
    }
  };

  const [color, setColor] = useState("");
  const handleColorChange = (e) => {
    setColor(e.target.value);
  };

  useEffect(() => {
    cornerstoneTools.toolColors.setToolColor(color);
  }, [color]);

  useEffect(() => {
    setColor(patientPreferencesObject.color);
  }, [patientPreferencesObject]);

  const smartViewAvailable = () => {
    return patientPreferencesObject?.smartView?.filter((view) => {
      if (Array.isArray(view.mainTest)) {
        return _.find(
          view.mainTest,
          (v) => v === props.activeDocument?.metadata?.procedureName,
        );
      } else {
        return view.mainTest === props.activeDocument?.metadata?.procedureName;
      }
    });
  };

  return (
    <div>
      <MessageBox
        onClose={() => {
          setConfirmOpen(false);
        }}
        title={t("Confirmation")}
        haveAccept={{ yes: t("Save"), no: t("Close") }}
        onAccept={() => {
          if (props.renderXupImage) props.renderXupImage();
          setConfirmOpen(false);
        }}
        message={t(
          "Please keep in mind that all the annotations will become the integral part of the generated document and there for they will not be treated as the annotations within the new document. If you have made changes to annotations on documents, remember to save them.",
        )}
        open={!!confirmOpen}
      />

      <div className={clsx(classes.toolbarCenter, props.isFramesViewActive && classes.toolbarDisabledCenter)}>
        <div className={classes.toolbarNumber}>
          {props.position} / {props.positionMax}
        </div>
      </div>

      <div className={classes.toolbarRight}>
        <ToolbarButtonGroupMain>
          <Tooltip title={t("Open first document")}>
            <ToolbarButton
              disabled={props.position <= 1}
              onClick={sendOpenToParent(0)}
            >
              <FirstFrameIcon />
            </ToolbarButton>
          </Tooltip>
          <Tooltip title={t("Open previous document")}>
            <ToolbarButton
              disabled={props.position <= 1}
              onClick={sendOpenToParent(props.position - 2)}
            >
              <PreviousFrameIcon />
            </ToolbarButton>
          </Tooltip>
          <Tooltip title={t("Open next document")}>
            <ToolbarButton
              disabled={props.position >= props.positionMax}
              onClick={sendOpenToParent(props.position)}
            >
              <NextFrameIcon />
            </ToolbarButton>
          </Tooltip>
          <Tooltip title={t("Open last document")}>
            <ToolbarButton
              disabled={props.position >= props.positionMax}
              onClick={sendOpenToParent(props.positionMax - 1)}
            >
              <LastFrameIcon />
            </ToolbarButton>
          </Tooltip>
        </ToolbarButtonGroupMain>
      </div>

      <ToolbarMainTBG value={windows} onChange={handleMainToolbar}>
        <ToolbarMainToggleButton value="view">
          <Tooltip title={t("Viewing tools")}>
            <div className={"toggle-with-tooltip"}>
              <ViewMenuIcon />
              <div className={"dot-below"} />
            </div>
          </Tooltip>
        </ToolbarMainToggleButton>
        {toolbarViewer &&
          toolbarViewer.mode === "dicom" &&
          !props.isFramesViewActive && (
            <ToolbarMainToggleButton value="enhance">
              <Tooltip title={t("Enhancement tools")}>
                <div className={"toggle-with-tooltip"}>
                  <EnhanceMenuIcon />
                  <div className={"dot-below"} />
                </div>
              </Tooltip>
            </ToolbarMainToggleButton>
          )}
        {/* {toolbarViewer && toolbarViewer.mode === "dicom" &&
                    <ToolbarMainToggleButton value="measurement">
                        <Tooltip title={t("Measurement tools")}>
                            <div className={"toggle-with-tooltip"}>
                                <MeasurementMenuIcon />
                                <div className={"dot-below"} />
                            </div>
                        </Tooltip>
                    </ToolbarMainToggleButton>
                } */}
        {toolbarViewer &&
          toolbarViewer.mode === "dicom" &&
          !props.isFramesViewActive && (
            <ToolbarMainToggleButton value="drawing">
              <Tooltip title={t("Drawing and measure tools")}>
                <div className={"toggle-with-tooltip"}>
                  <DrawingMenuIcon />
                  <div className={"dot-below"} />
                </div>
              </Tooltip>
            </ToolbarMainToggleButton>
          )}
        {!props.historyMode && !isHoldingPen && !props.isFramesViewActive && (
          <ToolbarMainToggleButton value="study">
            <Tooltip title={t("Previous studies")}>
              <div className={"toggle-with-tooltip"}>
                <StudyListMenuIcon />
                <div className={"dot-below"} />
              </div>
            </Tooltip>
          </ToolbarMainToggleButton>
        )}
        {!isHoldingPen && !props.isFramesViewActive && (
          <ToolbarMainToggleButton value="change-grid">
            <Tooltip title={t("Grid settings")}>
              <div className={"toggle-with-tooltip"}>
                <XupGridIcon />
                <div className={"dot-below"} />
              </div>
            </Tooltip>
          </ToolbarMainToggleButton>
        )}
        {appList && appList.keys.length > 0 && (
          <ToolbarMainToggleButton value="app">
            <Tooltip title={t("Application")}>
              <div className={"toggle-with-tooltip"}>
                <AppIcon style={{ fill: "white" }} />
                <div className={"dot-below"} />
              </div>
            </Tooltip>
          </ToolbarMainToggleButton>
        )}

        {/* FIXME: !!! */}
        {/* {props.historyMode &&
                    <ToolbarMainColorToggleButton value="open-history-od-os">
                        <Tooltip title={t("Split OD/OS")}>
                            <div className={"toggle-with-tooltip"}>
                                <SplitODOSIcon />
                            </div>
                        </Tooltip>
                    </ToolbarMainColorToggleButton>
                } */}

        {!props.smartViewMode && !props.historyMode &&
          (props.documents?.length === 1 || props.splitStatus) &&
          smartViewAvailable().length > 0 && (
            <ToolbarMainToggleButton value="smart-view">
              <Tooltip title={t("Smart View")}>
                <div className={"toggle-with-tooltip"}>
                  <SmartViewIcon style={{ fill: "white" }} />
                  <div className={"dot-below"} />
                </div>
              </Tooltip>
            </ToolbarMainToggleButton>
          )}

        {_.indexOf(windows, "smart-view-open") >= 0 && (
          <ToolbarMainColorToggleButton value="smart-view-close">
            <Tooltip title={t("Smart View")}>
              <div className={"toggle-with-tooltip"}>
                <SmartViewIcon style={{ fill: "#2280f7" }} />
                <div className={"dot-below"} />
              </div>
            </Tooltip>
          </ToolbarMainColorToggleButton>
        )}
        {props.documents &&
          !props.smartViewMode &&
          !isHoldingPen &&
          !props.isFramesViewActive && (
            <ToolbarMainColorToggleButton value="open-history">
              <Tooltip title={t("Toggle history")}>
                <div className={"toggle-with-tooltip"}>
                  <HistoryIcon />
                </div>
              </Tooltip>
            </ToolbarMainColorToggleButton>
          )}
        {!props.historyMode &&
          props.relatedDocument &&
          props.relatedDocument[props.viewerId - 1] && (
            <ToolbarMainColorToggleButton value="open-related">
              <Tooltip title={t("Open related")}>
                <div className={"toggle-with-tooltip"}>
                  <SplitMenuIcon />
                </div>
              </Tooltip>
            </ToolbarMainColorToggleButton>
          )}
        {props.relatedDocument && !props.documentFramesView && !props.splitStatus &&
            (
            <ToolbarMainColorToggleButton value="switch-related">
              <Tooltip title={t("Switch related")}>
                <div className={"toggle-with-tooltip"}>
                  <SwitchEyonixIcon />
                </div>
              </Tooltip>
            </ToolbarMainColorToggleButton>
          )}
        {!props.historyMode &&
          !props.smartViewMode &&
          props.positionMaxLaterality > 0 &&
          (props.splitStatus ||
            (props.documents && props.documents.length === 1)) && (
            <ToolbarMainColorToggleButton value="open-od-os">
              <Tooltip title={t("Split OD/OS")}>
                <div className={"toggle-with-tooltip"}>
                  <SplitODOSIcon />
                </div>
              </Tooltip>
            </ToolbarMainColorToggleButton>
          )}
      </ToolbarMainTBG>
      <ToolbarMainTBG
        value={toolbarViewer ? toolbarViewer.imageInformation : null}
        exclusive
        onChange={handleInfo}
      >
        <ToolbarMainColorToggleButton value="info">
          <Tooltip title={t("Image information")}>
            <div className={"toggle-with-tooltip"}>
              <InfoMenuIcon />
            </div>
          </Tooltip>
        </ToolbarMainColorToggleButton>
      </ToolbarMainTBG>
      {props.relatedDocument &&
        props.relatedDocument[props.viewerId - 1] &&
        props.viewerId < 999 &&
        !props.isFramesViewActive && (
          <ToolbarMainTBG
            value={toolbarViewer ? toolbarViewer.relatedVisible : null}
            exclusive
            onChange={handleRelatedVisible}
          >
            <ToolbarMainColorToggleButton value="related">
              <Tooltip title={t("Related visible")}>
                <div className={"toggle-with-tooltip"}>
                  <RelatedEyonixIcon />
                </div>
              </Tooltip>
            </ToolbarMainColorToggleButton>
          </ToolbarMainTBG>
        )}

      {props.relatedDocument && props.relatedDocument.length == 1 &&
          props.relatedDocument[props.viewerId - 1] &&
         props.relatedDocument[props.viewerId - 1].pageCount !== 1 &&
        props.viewerId < 999 && (
          <ToolbarMainTBG
            value={props.documentFramesView? "related-frames": null}
            exclusive
            onChange={handleRelatedFramesVisible}
          >
            <ToolbarMainColorToggleButton value={"related-frames"}>
              <Tooltip title={t("Related Frames visible")}>
                <div className={"toggle-with-tooltip"}>
                  <AppsIcon />
                </div>
              </Tooltip>
            </ToolbarMainColorToggleButton>
          </ToolbarMainTBG>
        )}

      {/* {!(_.indexOf(windows, "open-od-os") >= 0) &&
                <ToolbarMainTBG style={{ marginLeft: -10 }}>
                    <ToolbarButton onClick={sendQuickAction("fullscreen")}>
                        <Tooltip title={t("Fullscreen")}>
                            <div className={"toggle-with-tooltip"}>
                                <FullScreenIcon />
                            </div>
                        </Tooltip>
                    </ToolbarButton>
                </ToolbarMainTBG>
            }
            <ToolbarMainTBG style={{ marginLeft: -10 }}>
                <ToolbarButton onClick={sendQuickAction("saveDOR")}>
                    <Tooltip title={t("Save document of record")}>
                        <div className={"toggle-with-tooltip"}>
                            <SaveIcon />
                        </div>
                    </Tooltip>
                </ToolbarButton>
            </ToolbarMainTBG> */}

      {/*<EnhanceMenuIcon color="secondary"/>*/}
      {/*<MeasurementMenuIcon color="action"/>*/}
      {/*<DrawingMenuIcon color="disabled"/>*/}
      {/*<StudyListMenuIcon style={{color: "#0a0"}}/>*/}
      {/*<SplitMenuIcon color="primary"/>*/}
      {/*<InfoMenuIcon color="primary"/>*/}
      {/*TOOLBAR here !*/}

      {/* TODO: left, top into local session ??? */}

      <ToolbarWindow
        title={"Viewing"}
        left={1}
        top={5}
        active={_.indexOf(windows, "view") >= 0}
      >
        {/* FIXME: color fix */}
        <div className={classes.toolbarElement}>
          <div>
            <ToolbarSubTBG value={viewMode} exclusive onChange={handleViewMode}>
              <ToolbarSubToggleButton value="v1x1">
                <Tooltip title={t("1x1 View")}>
                  <div className={"toggle-with-tooltip"}>
                    <View11Icon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="v2x1">
                <Tooltip title={t("2x1 View")}>
                  <div className={"toggle-with-tooltip"}>
                    <View21Icon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="v3x1">
                <Tooltip title={t("3x1 View")}>
                  <div className={"toggle-with-tooltip"}>
                    <View31Icon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="v2x2">
                <Tooltip title={t("2x2 View")}>
                  <div className={"toggle-with-tooltip"}>
                    <View2x2Icon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
            </ToolbarSubTBG>
          </div>
          {/* <div>
                        <ToolbarSubTBG value={viewMode} exclusive onChange={handleViewMode}>
                            <ToolbarSubToggleButton value="v2x2">
                                <Tooltip title={t("2x2 View")}>
                                    <div className={"toggle-with-tooltip"}>
                                        <View2x2Icon />
                                    </div>
                                </Tooltip>
                            </ToolbarSubToggleButton>
                        </ToolbarSubTBG>
                    </div> */}
        </div>

        <div
          className={clsx([
            classes.toolbarElement,
            classes.toolbarElementSpacing,
          ])}
        >
          <div>
            <ToolbarButtonGroup>
              <ToolbarButton
                disabled={
                  !(_.indexOf(windows, "open-od-os") >= 0) &&
                  props.documents &&
                  // props.documents.length < 2
                  props.documents.length !== 2
                }
                onClick={props.onSwitch}
              >
                <Tooltip title={t("Switch windows")}>
                  <div className={"toggle-with-tooltip"}>
                    <SwitchIcon />
                  </div>
                </Tooltip>
              </ToolbarButton>
              <ToolbarButton
                disabled={_.indexOf(windows, "open-od-os") >= 0}
                onClick={sendQuickAction("fullscreen")}
              >
                <Tooltip title={t("Fullscreen")}>
                  <div className={"toggle-with-tooltip"}>
                    <Fullscreen2Icon />
                  </div>
                </Tooltip>
              </ToolbarButton>
              <ToolbarButton onClick={sendQuickAction("fitToWindowAction")}>
                <Tooltip title={t("Fit to window")}>
                  <div className={"toggle-with-tooltip"}>
                    <FitToScreeIcon />
                  </div>
                </Tooltip>
              </ToolbarButton>
            </ToolbarButtonGroup>
          </div>
        </div>

        {/*<div className={clsx([classes.toolbarElement, classes.toolbarElementSpacing])}>*/}
        {/*    <div>*/}
        {/*        <ToolbarSubTBG value={toolbarViewer ? toolbarViewer.grid : null}*/}
        {/*                       exclusive*/}
        {/*                       onChange={handleGridMode}>*/}
        {/*            <ToolbarSubToggleButton value="gridA">*/}
        {/*                <Tooltip title={t("Grid A")}>*/}
        {/*                    <div className={"toggle-with-tooltip"}>*/}
        {/*                        <EyonixGridA style={{stroke: "white", strokeWidth: 40}}/>*/}
        {/*                    </div>*/}
        {/*                </Tooltip>*/}
        {/*            </ToolbarSubToggleButton>*/}
        {/*            <ToolbarSubToggleButton value="gridB">*/}
        {/*                <Tooltip title={t("Grid B")}>*/}
        {/*                    <div className={"toggle-with-tooltip"}>*/}
        {/*                        <EyonixGridB style={{stroke: "white", strokeWidth: 40}}/>*/}
        {/*                    </div>*/}
        {/*                </Tooltip>*/}
        {/*            </ToolbarSubToggleButton>*/}
        {/*            <ToolbarSubToggleButton value="gridC">*/}
        {/*                <Tooltip title={t("Grid C")}>*/}
        {/*                    <div className={"toggle-with-tooltip"}>*/}
        {/*                        <EyonixGridC style={{stroke: "white", strokeWidth: 40}}/>*/}
        {/*                    </div>*/}
        {/*                </Tooltip>*/}
        {/*            </ToolbarSubToggleButton>*/}
        {/*        </ToolbarSubTBG>*/}
        {/*    </div>*/}
        {/*</div>*/}
        <div
          className={clsx([
            classes.toolbarElement,
            classes.toolbarElementSpacing,
          ])}
        >
          <div>
            <ToolbarButtonGroup>
              <ToolbarButton onClick={sendQuickAction("actualSizeAction")}>
                <Tooltip title={t("Actual size")}>
                  <div className={"toggle-with-tooltip"}>
                    <ActualSizeViewIcon />
                  </div>
                </Tooltip>
              </ToolbarButton>
              <ToolbarButton onClick={sendQuickAction("fullHeightAction")}>
                <Tooltip title={t("Full height")}>
                  <div className={"toggle-with-tooltip"}>
                    <FullHeightIcon />
                  </div>
                </Tooltip>
              </ToolbarButton>
              <ToolbarButton onClick={sendQuickAction("fullWidthAction")}>
                <Tooltip title={t("Full width")}>
                  <div className={"toggle-with-tooltip"}>
                    <FullWidthIcon />
                  </div>
                </Tooltip>
              </ToolbarButton>
            </ToolbarButtonGroup>
          </div>
          {/* <div>
                        <ToolbarButtonGroup>
                            <ToolbarButton onClick={sendQuickAction("actualSizeAction")}>
                                <Tooltip title={t("Actual size")}>
                                    <div className={"toggle-with-tooltip"}>
                                        <ActualSizeViewIcon />
                                    </div>
                                </Tooltip>
                            </ToolbarButton>
                        </ToolbarButtonGroup>
                    </div> */}
          <div>
            <ToolbarSubTBG
              value={toolbarViewer ? toolbarViewer.activeMethod : null}
              exclusive
              onChange={handleActiveMethod}
            >
              {toolbarViewer && toolbarViewer.mode === "non-dicom" && (
                <ToolbarSubToggleButton value="pointer">
                  <Tooltip title={t("TO DO")}>
                    <div className={"toggle-with-tooltip"}>
                      <PointerIcon />
                    </div>
                  </Tooltip>
                </ToolbarSubToggleButton>
              )}
              <ToolbarSubToggleButton value="pan">
                <Tooltip title={t("Pan")}>
                  <div className={"toggle-with-tooltip"}>
                    <PanIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="zoom">
                <Tooltip title={t("Zoom")}>
                  <div className={"toggle-with-tooltip"}>
                    <ZoomIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              {toolbarViewer && toolbarViewer.mode === "dicom" && (
                <ToolbarSubToggleButton value="flying-zoom">
                  <Tooltip title={t("Loupe")}>
                    <div className={"toggle-with-tooltip"}>
                      <FlyingZoomIcon />
                    </div>
                  </Tooltip>
                </ToolbarSubToggleButton>
              )}
            </ToolbarSubTBG>
          </div>
        </div>
      </ToolbarWindow>

      <ToolbarWindow
        title={"Enhance"}
        left={positionToolbarWindow("enhance")}
        top={6}
        active={
          _.indexOf(windows, "enhance") >= 0 &&
          toolbarViewer &&
          toolbarViewer.mode === "dicom"
        }
      >
        <div className={classes.toolbarElement}>
          <div>
            <ToolbarSubTBG
              value={toolbarViewer ? toolbarViewer.enhanceMode : null}
              disabled={disabledTools()}
              onChange={handleEnhanceMode}
            >
              <ToolbarSubToggleButton value="sharpen">
                <Tooltip title={t("Sharpen")}>
                  <div className={"toggle-with-tooltip"}>
                    <SharpenIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>

              <ToolbarSubToggleButton value="blur">
                <Tooltip title={t("Blur")}>
                  <div className={"toggle-with-tooltip"}>
                    <SmoothIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="negative">
                <Tooltip title={t("Negative")}>
                  <div className={"toggle-with-tooltip"}>
                    <NegativeIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
            </ToolbarSubTBG>
          </div>
          <div>
            <ToolbarSubTBG
              value={toolbarViewer ? toolbarViewer.enhanceMode : null}
              disabled={disabledTools()}
              onChange={handleEnhanceMode}
            >
              <ToolbarSubToggleButton value="brightness">
                <Tooltip title={t("Brightness")}>
                  <div className={"toggle-with-tooltip"}>
                    <BrightnessIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="contrast">
                <Tooltip title={t("Contrast")}>
                  <div className={"toggle-with-tooltip"}>
                    <ContrastIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>

              <ToolbarSubToggleButton value="gamma">
                <Tooltip title={t("Gamma")}>
                  <div className={"toggle-with-tooltip"}>
                    <GammaIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
            </ToolbarSubTBG>
          </div>
        </div>
        <div
          className={clsx([
            classes.toolbarElement,
            classes.toolbarElementSpacing,
          ])}
        >
          <div>
            <ToolbarSubTBG
              disabled={disabledTools()}
              value={toolbarViewer ? toolbarViewer.channelsMode : null}
              exclusive
              onChange={handleChannelsMode}
            >
              <ToolbarSubToggleButton value="rChannel">
                <Tooltip title={t("Red")}>
                  <div className={"toggle-with-tooltip"}>
                    <RIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="gChannel">
                <Tooltip title={t("Green")}>
                  <div className={"toggle-with-tooltip"}>
                    <GIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="bChannel">
                <Tooltip title={t("Blue")}>
                  <div className={"toggle-with-tooltip"}>
                    <BIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
            </ToolbarSubTBG>
          </div>
          {canModifyDocument && (
            <ToolbarButtonGroupMain>
              <ToolbarButton
                  disabled={disabledTools()}
                  onClick={sendQuickAction("rotate-page-left")}
              >
                <Tooltip title={t("Rotate Document")}>
                  <div className={"toggle-with-tooltip"}>
                    <RotateLeftIcon />
                  </div>
                </Tooltip>
              </ToolbarButton>
              <ToolbarButton
                  disabled={disabledTools()}
                  onClick={sendQuickAction("rotate-page")}
              >
                <Tooltip title={t("Rotate Document")}>
                  <div className={"toggle-with-tooltip"}>
                    <RotateRightIcon />
                  </div>
                </Tooltip>
              </ToolbarButton>
              <ToolbarButton
                disabled={disabledTools() || savingDor}
                onClick={sendQuickAction(
                  isHoldingPen ? "replaceDOR" : "saveDOR",
                )}
              >
                <Tooltip title={t("Save document of record")}>
                  <div className={"toggle-with-tooltip"}>
                    <SaveIcon />
                  </div>
                </Tooltip>
              </ToolbarButton>
            </ToolbarButtonGroupMain>
          )}
        </div>

        {/*
                <div className={clsx([classes.toolbarElement, classes.toolbarElementSpacingText])}>
                    <div>
                        <div>
                            <div className={classes.sliderLabel1}>
                                Zoom
                            </div>
                            <div className={classes.sliderLabel2}>
                                {valueZoom}%
                            </div>
                        </div>
                        <div className={classes.sliderElement}>
                            <Slider value={valueZoom}
                                    onChangeCommitted={() => {
                                        alert('TODO: ??: ' + valueZoom);
                                    }}
                                    onChange={handleValueChange(setValueZoom)}/>
                        </div>
                    </div>
                </div>
                */}

        {toolbarViewer &&
          _.indexOf(toolbarViewer.enhanceMode, "sharpen") >= 0 && (
            <div
              className={clsx([
                classes.toolbarElement,
                classes.toolbarElementSpacingText,
              ])}
            >
              <div>
                <div>
                  <div className={classes.sliderLabel1}>Sharpen</div>
                  <div className={classes.sliderLabel2}>
                    {sliderValue["sharpen"] === 0
                      ? t("Off")
                      : sliderValue["sharpen"] + "%"}
                  </div>
                </div>
                <div className={classes.sliderElement}>
                  <Slider
                    value={sliderValue["sharpen"]}
                    onChange={handleSliderValueChange("sharpen")}
                    onChangeCommitted={handlePropertyValueChange("sharpen")}
                  />
                </div>
              </div>
            </div>
          )}

        {toolbarViewer && _.indexOf(toolbarViewer.enhanceMode, "blur") >= 0 && (
          <div
            className={clsx([
              classes.toolbarElement,
              classes.toolbarElementSpacingText,
            ])}
          >
            <div>
              <div>
                <div className={classes.sliderLabel1}>Blur</div>
                <div className={classes.sliderLabel2}>
                  {sliderValue["blur"]}%
                </div>
              </div>
              <div className={classes.sliderElement}>
                <Slider
                  value={sliderValue["blur"]}
                  onChange={handleSliderValueChange("blur")}
                  onChangeCommitted={handlePropertyValueChange("blur")}
                />
              </div>
            </div>
          </div>
        )}

        {toolbarViewer &&
          _.indexOf(toolbarViewer.enhanceMode, "brightness") >= 0 && (
            <div
              className={clsx([
                classes.toolbarElement,
                classes.toolbarElementSpacingText,
              ])}
            >
              <div>
                <div>
                  <div className={classes.sliderLabel1}>Brightness</div>
                  <div className={classes.sliderLabel2}>
                    {toolbarViewer.enhanceModeParameters.brightness}%
                  </div>
                </div>
                <div className={classes.sliderElement}>
                  <Slider
                    min={-100}
                    value={toolbarViewer.enhanceModeParameters.brightness}
                    onChange={handlePropertyValueChange("brightness")}
                  />
                </div>
              </div>
            </div>
          )}

        {toolbarViewer &&
          _.indexOf(toolbarViewer.enhanceMode, "contrast") >= 0 && (
            <div
              className={clsx([
                classes.toolbarElement,
                classes.toolbarElementSpacingText,
              ])}
            >
              <div>
                <div>
                  <div className={classes.sliderLabel1}>Contrast</div>
                  <div className={classes.sliderLabel2}>
                    {toolbarViewer.enhanceModeParameters.contrast}%
                  </div>
                </div>
                <div className={classes.sliderElement}>
                  <Slider
                    min={-100}
                    value={toolbarViewer.enhanceModeParameters.contrast}
                    onChange={handlePropertyValueChange("contrast")}
                  />
                </div>
              </div>
            </div>
          )}

        {toolbarViewer &&
          _.indexOf(toolbarViewer.enhanceMode, "gamma") >= 0 && (
            <div
              className={clsx([
                classes.toolbarElement,
                classes.toolbarElementSpacingText,
              ])}
            >
              <div>
                <div>
                  <div className={classes.sliderLabel1}>Gamma</div>
                  <div className={classes.sliderLabel2}>
                    {toolbarViewer.enhanceModeParameters.gamma}%
                  </div>
                </div>
                <div className={classes.sliderElement}>
                  <Slider
                    min={-100}
                    value={toolbarViewer.enhanceModeParameters.gamma}
                    onChange={handlePropertyValueChange("gamma")}
                  />
                </div>
              </div>
            </div>
          )}
      </ToolbarWindow>

      <ToolbarWindow
        title={"Measurement"}
        left={330 + 45}
        top={7}
        active={
          _.indexOf(windows, "measurement") >= 0 &&
          toolbarViewer &&
          toolbarViewer.mode === "dicom"
        }
      >
        <div className={classes.toolbarElement}>
          <ToolbarSubTBG
            value={toolbarViewer ? toolbarViewer.activeMethod : null}
            exclusive
            onChange={handleActiveMethod}
          >
            <ToolbarSubToggleButton value="measure">
              <Tooltip title={t("Measure")}>
                <div className={"toggle-with-tooltip"}>
                  <MeasureIcon />
                </div>
              </Tooltip>
            </ToolbarSubToggleButton>
            <ToolbarSubToggleButton value="measure-multi-point">
              <Tooltip title={t("Measure multi point")}>
                <div className={"toggle-with-tooltip"}>
                  <MeasureMultiPointIcon />
                </div>
              </Tooltip>
            </ToolbarSubToggleButton>
            <ToolbarSubToggleButton value="measure-area">
              <Tooltip title={t("Measure Area")}>
                <div className={"toggle-with-tooltip"}>
                  <AreaIcon />
                </div>
              </Tooltip>
            </ToolbarSubToggleButton>
          </ToolbarSubTBG>
        </div>
      </ToolbarWindow>

      <ToolbarWindow
        title={t("Draw and measure")}
        left_={490}
        left={positionToolbarWindow("drawing")}
        top={8}
        active={
          _.indexOf(windows, "drawing") >= 0 &&
          toolbarViewer &&
          toolbarViewer.mode === "dicom"
        }
      >
        <div className={classes.toolbarElement}>
          <div>
            <ToolbarSubTBG
              value={toolbarViewer ? toolbarViewer.activeMethod : null}
              exclusive
              disabled={disabledTools()}
              onChange={handleActiveMethod}
            >
              <ToolbarSubToggleButton value="draw-arrow">
                <Tooltip title={t("Draw arrow")}>
                  <div className={"toggle-with-tooltip"}>
                    <ArrowIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="draw-line">
                <Tooltip title={t("Draw line")}>
                  <div className={"toggle-with-tooltip"}>
                    <LineIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="draw-free-hand">
                <Tooltip title={t("Draw free hand")}>
                  <div className={"toggle-with-tooltip"}>
                    <FreehandIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton
                value="draw-free-hand-pdt"
                disabled={
                  toolbarViewer ? !toolbarViewer.haveSquareMeasurements : true
                }
              >
                <Tooltip title={t("PDT")}>
                  <div className={"toggle-with-tooltip"}>PDT</div>
                </Tooltip>
              </ToolbarSubToggleButton>
            </ToolbarSubTBG>
          </div>
          <div>
            <ToolbarSubTBG
              value={toolbarViewer ? toolbarViewer.activeMethod : null}
              exclusive
              disabled={disabledTools()}
              onChange={handleActiveMethod}
            >
              {/*<ToolbarSubToggleButton value="draw-text">*/}
              {/*  <Tooltip title={t("Draw text")}>*/}
              {/*    <div className={"toggle-with-tooltip"}>*/}
              {/*      <TextIcon />*/}
              {/*    </div>*/}
              {/*  </Tooltip>*/}
              {/*</ToolbarSubToggleButton>*/}
              <ToolbarSubToggleButton value="draw-resize-text">
                <Tooltip title={t("Draw text")}>
                  <div className={"toggle-with-tooltip"}>
                    <TextFieldsIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>

              {/*
                            <ToolbarSubToggleButton value="draw-circle">
                                <Tooltip title={t("Draw circle")}>
                                    <div className={"toggle-with-tooltip"}>
                                        <CircleIcon />
                                    </div>
                                </Tooltip>
                            </ToolbarSubToggleButton>
                            */}
              <ToolbarSubToggleButton value="draw-ellipse">
                <Tooltip title={t("Draw ellipse")}>
                  <div className={"toggle-with-tooltip"}>
                    <EllipseIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="draw-rect">
                <Tooltip title={t("Draw rectangle")}>
                  <div className={"toggle-with-tooltip"}>
                    <RectangleIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
            </ToolbarSubTBG>
          </div>
          <div>
            <ToolbarSubTBG
              value={toolbarViewer ? toolbarViewer.activeMethod : null}
              exclusive
              disabled={disabledTools()}
              onChange={handleActiveMethod}
            >
              <ToolbarSubToggleButton value="angle-tool">
                <Tooltip title={t("Angle tool")}>
                  <div className={"toggle-with-tooltip"}>
                    <AngleIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="eraser-tool">
                <Tooltip title={t("Eraser")}>
                  <div className={"toggle-with-tooltip"}>
                    <TrashIcon />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              {canModifyDocument && (
                <ToolbarSubToggleButton
                    disabled={savingDor}
                  onClick={sendQuickAction(
                    isHoldingPen ? "replaceDOR" : "saveDOR",
                  )}
                >
                  <Tooltip title={t("Save document of record")}>
                    <div className={"toggle-with-tooltip"}>
                      <SaveIcon />
                    </div>
                  </Tooltip>
                </ToolbarSubToggleButton>
              )}
              {config.modules.viewer.drugAllergyFormEnabled && (
                <ToolbarSubToggleButton value="draw-form">
                  <Tooltip title={t("Drug Allergy Form")}>
                    <div className={"toggle-with-tooltip"}>
                      <MedicationIcon />
                    </div>
                  </Tooltip>
                </ToolbarSubToggleButton>
              )}
              {canModifyDocument && props.isXupView && (
                <ToolbarSubToggleButton
                  onClick={() => {
                    setConfirmOpen(true);
                  }}
                >
                  <Tooltip title={t("Save documents as new of record")}>
                    <div className={"toggle-with-tooltip"}>
                      <AddAPhotoIcon />
                    </div>
                  </Tooltip>
                </ToolbarSubToggleButton>
              )}
            </ToolbarSubTBG>
          </div>
          <div>
            <ToolbarSubTBG
              value={toolbarViewer ? toolbarViewer.activeMethod : null}
              exclusive
              disabled={disabledTools()}
              onChange={handleActiveMethod}
            >
              <ToolbarSubToggleButton value="grid-view">
                <Tooltip title={t("Grid A")}>
                  <div className={"toggle-with-tooltip"}>
                    <EyonixGridA style={{ stroke: "white", strokeWidth: 40 }} />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>

              <ToolbarSubToggleButton value="grid-view-B">
                <Tooltip title={t("Grid B")}>
                  <div className={"toggle-with-tooltip"}>
                    <EyonixGridB style={{ stroke: "white", strokeWidth: 40 }} />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="grid-view-C">
                <Tooltip title={t("Grid C")}>
                  <div className={"toggle-with-tooltip"}>
                    <EyonixGridC style={{ stroke: "white", strokeWidth: 40 }} />
                  </div>
                </Tooltip>
              </ToolbarSubToggleButton>
            </ToolbarSubTBG>
          </div>
          {/*
                     <div>
                        <ToolbarSubTBG value={toolbarViewer ? toolbarViewer.activeMethod : null} exclusive
                            onChange={handleActiveMethod}>\
                                <ToolbarSubToggleButton value="draw-text">
                                <Tooltip title={t("Draw text")}>
                                    <div className={"toggle-with-tooltip"}>
                                        <TextIcon />
                                    </div>
                                </Tooltip>
                            </ToolbarSubToggleButton>
                            <ToolbarSubToggleButton value="draw-annotation">
                                <Tooltip title={t("Draw annotation")}>
                                    <div className={"toggle-with-tooltip"}>
                                        <AnnotationIcon />
                                    </div>
                                </Tooltip>
                            </ToolbarSubToggleButton>
                        </ToolbarSubTBG>
                    </div>
                    */}
        </div>

        <div
          className={clsx([
            classes.toolbarElement,
            classes.toolbarElementSpacing,
          ])}
        >
          <div>
            {/*
                         <ToolbarButtonGroup>
                            <ToolbarButton onClick={sendQuickAction("actualSizeAction")}>
                                <Tooltip title={t("Actual size")}>
                                    <div className={"toggle-with-tooltip"}>
                                        <ActualSizeViewIcon />
                                    </div>
                                </Tooltip>
                            </ToolbarButton>
                        </ToolbarButtonGroup>
                        */}

            {toolbarViewer && (
              <div className={classes.selectorItem}>
                <FormControl className={classes.selectorItemFormControl}>
                  <InputLabel className={classes.selectorItemLabel}>
                    {t("Text size")}
                  </InputLabel>
                  <Select
                    variant="standard"
                    value={toolbarViewer.toolsProperties.fontSize}
                    onChange={handleToolPropertyValueChange("fontSize")}
                    className={classes.selectorItemSelect}
                    MenuProps={MenuProps}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                    <MenuItem value={14}>14</MenuItem>
                    <MenuItem value={16}>16</MenuItem>
                    <MenuItem value={18}>18</MenuItem>
                    <MenuItem value={24}>24</MenuItem>
                    <MenuItem value={36}>36</MenuItem>
                    <MenuItem value={42}>42</MenuItem>
                    <MenuItem value={48}>48</MenuItem>
                    <MenuItem value={54}>54</MenuItem>
                    <MenuItem value={58}>58</MenuItem>
                    <MenuItem value={64}>64</MenuItem>
                    <MenuItem value={68}>68</MenuItem>
                    <MenuItem value={72}>72</MenuItem>
                  </Select>
                </FormControl>
              </div>
            )}
            {toolbarViewer && (
              <div className={classes.selectorItem}>
                <FormControl className={classes.selectorItemFormControl}>
                  <InputLabel className={classes.selectorItemLabel}>
                    {t("Color")}
                  </InputLabel>
                  <Select
                    renderValue={(value) => {
                      return (
                        <div>
                          {" "}
                          <input
                            style={{ width: "95%" }}
                            type="color"
                            name="body"
                            value={value}
                          />
                        </div>
                      );
                    }}
                    variant="standard"
                    value={color}
                    onChange={handleColorChange}
                    className={classes.selectorItemSelect}
                  >
                    {config?.annotationsColor?.map((color) => {
                      return (
                        <MenuItem value={color}>
                          <input
                            type="color"
                            disabled
                            style={{ width: "95%", pointerEvents: "none" }}
                            name="body"
                            value={color}
                          />
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            )}
            {toolbarViewer && (
              <div className={classes.selectorItem}>
                <FormControl className={classes.selectorItemFormControl}>
                  <FormControlLabel
                    control={<Checkbox />}
                    label={t("with measurement")}
                    checked={withText}
                    onChange={handleAnnotationText}
                  />
                </FormControl>
              </div>
            )}
          </div>
        </div>
      </ToolbarWindow>

      <ToolbarWindow
        title={t("X-Up settings")}
        left={positionToolbarWindow("change-grid")}
        top={10}
        active={_.indexOf(windows, "change-grid") >= 0}
      >
        <div className={classes.toolbarElement}>
          <div>
            <ToolbarSubTBG
              value={toolbarViewer ? toolbarViewer.activeXUP : null}
              exclusive
              onChange={handleActiveGrid}
            >
              <ToolbarSubToggleButton value="grid-clear">
                <Tooltip title={t("Clear X-Up")}>
                  <div className={"toggle-with-tooltip"}>CLR</div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="grid2x2">
                <Tooltip title={t("X-Up 2x2")}>
                  <div className={"toggle-with-tooltip"}>2x2</div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="grid3x2">
                <Tooltip title={t("X-Up 3x2")}>
                  <div className={"toggle-with-tooltip"}>3x2</div>
                </Tooltip>
              </ToolbarSubToggleButton>
              <ToolbarSubToggleButton value="grid3x3">
                <Tooltip title={t("X-Up 3x3")}>
                  <div className={"toggle-with-tooltip"}>3x3</div>
                </Tooltip>
              </ToolbarSubToggleButton>
            </ToolbarSubTBG>
          </div>
        </div>
      </ToolbarWindow>

      <ToolbarWindow
        title={t("Studies list")}
        left={positionToolbarWindow("study")}
        top={9}
        active={_.indexOf(windows, "study") >= 0 && !props.historyMode}
      >
        {/* <ToolbarWindow title={t("Studies list")} left={490} top={5}
                active={_.indexOf(windows, "study") >= 0 && (toolbarViewer && toolbarViewer.mode === "dicom")}> */}

        <div className={classes.toolbarElement}>
          {props.activeDocument?.metadata?.procedureName && (
            <div className={classes.toolbarCheck}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={t(
                    "Only " + props.activeDocument?.metadata?.procedureName,
                  )}
                  checked={studiesByProcedureNameAvailable}
                  onChange={(ev) => {
                    setStudiesByProcedureNameAvailable(ev.target.checked);
                  }}
                />
              </FormGroup>
            </div>
          )}

          <PerfectScrollbar>
            <div className={classes.studiesList}>
              <div>
                <table className={classes.studiesListTable}>
                  <tbody>
                    {studiesAvailable.map((study, index) => (
                      <tr
                        key={`tbl${index}`}
                        onClick={
                          study.__isActive
                            ? () => {}
                            : openStudyInActiveView(study)
                        }
                      >
                        <td className={study.__isActive ? "active" : ""}>
                          <div
                            className={classes.studiesListColorDot}
                            style={{
                              backgroundColor: study.__colorString,
                            }}
                          >
                            &nbsp;
                          </div>
                        </td>
                        <td className={study.__isActive ? "active" : ""}>
                          <div className={classes.studiesListColorInfo}>
                            {Formatter.formatStringDate(t, study.startDate)}
                          </div>
                        </td>
                        <td className={study.__isActive ? "active" : ""}>
                          <div className={classes.studiesListColorInfo}>
                            <strong>
                              {Formatter.formatProcedureNameSimple(
                                t,
                                study.__typeString,
                              )}
                            </strong>{" "}
                            / {study.documents.length}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </ToolbarWindow>

      <ToolbarWindow
        title={t("App list")}
        left={positionToolbarWindow("app")}
        top={5}
        active={_.indexOf(windows, "app") >= 0}
      >
        <div className={classes.toolbarElement}>
          <PerfectScrollbar>
            <div className={classes.studiesList}>
              <div>
                <table className={classes.studiesListTable}>
                  <tbody>
                    {appList &&
                      appList.keys.map((key) => (
                        <tr key={key} onClick={openApp.bind(this, key)}>
                          <td>{appList.data[key].description}</td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </ToolbarWindow>

      <ToolbarWindow
        title={t("Smart View")}
        left={positionToolbarWindow("smart-view")}
        top={6}
        active={_.indexOf(windows, "smart-view") >= 0}
      >
        <div className={classes.toolbarElement}>
          <PerfectScrollbar>
            <div className={classes.studiesList}>
              <div>
                <table className={classes.studiesListTable}>
                  <tbody>
                    {patientPreferencesObject &&
                      smartViewAvailable().map((view) => (
                        <tr
                          key={view.name}
                          onClick={() => {
                            setSmartView(view);
                          }}
                        >
                          <td>{view.name}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </ToolbarWindow>
    </div>
  );
}

export default ToolbarDICOM;
